import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "ztsi-delete-confirmation",
  templateUrl: "ztsi-delete-confirmation-dialog.component.html",
  styleUrls: [],
})
export class ZtsiDeleteConfirmationDialogComponent implements OnInit {
  constructor(
    private _dialog: MatDialogRef<ZtsiDeleteConfirmationDialogComponent>
  ) {
  }

  ngOnInit() {
  }

  onConfirm() {
    this._dialog.close(true);
  }

  onCancel() {
    this._dialog.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-delete-confirmation-dialog/ztsi-delete-confirmation-dialog.component.ts